<template>
	<div>
		<field-name-slug v-model="field"></field-name-slug>

		<field-placeholder v-model="field"></field-placeholder>

		<div class="input-container">
			<div class="input-title">Select Module</div>
			<div class="input-box">
				<selectize v-model="field.specific_data" :settings="{ create: false }" placeholder="Select Module">
					<option v-for="parentModule in parentModules" :key="`parent-moduld-${ parentModule.id }`" :value="parentModule.plural_table_name">{{ parentModule.name }}</option>
				</selectize>
			</div>
		</div>

		<field-display-logic v-model="field" :module="module"></field-display-logic>

		<div class="input-container">
			<div class="input-checkbox">
				<span class="checkmark-container">
					<label class="checkbox">
						<input type="checkbox" :id="`single-select-${ value.id }`" v-model="value.config.single_select">
						<span class="checkmark"></span>
					</label>
				</span>
				<label :for="`single-select-${ value.id }`" class="input-checkbox-text">Single Select Dropdown</label>
			</div>
		</div>

		<div class="input-container">
			<div class="input-checkbox">
				<span class="checkmark-container">
					<label class="checkbox">
						<input type="checkbox" :id="`filtering-enabled-${ value.id }`" v-model="value.config.filtering_enabled">
						<span class="checkmark"></span>
					</label>
				</span>
				<label :for="`filtering-enabled-${ value.id }`" class="input-checkbox-text">Add Filtering</label>
			</div>
		</div>

		<div v-show="!!value.config.filtering_enabled" class="input-container">
			<div class="input-title">Filter Field Name</div>
			<div class="input-box">
				<selectize v-model="value.config.filter_column" :settings="{ create: false }">
					<option v-for="field in selectedModuleFields" :key="`field-${ value.id }-filter-field-${ field.id }`" :value="field.slug">{{ field.name }} ({{ field.slug }})</option>
				</selectize>
			</div>
		</div>

		<div v-show="!!value.config.filtering_enabled" class="input-container">
			<div class="input-title">Filter Operand</div>
			<div class="input-box">
				<input v-model="value.config.filter_operand" placeholder="e.g. =">
			</div>
		</div>

		<div v-show="!!value.config.filtering_enabled" class="input-container">
			<div class="input-title">Filter Field Value</div>
			<div class="input-box">
				<input v-model="value.config.filter_value" placeholder="e.g. Renaissance Fair">
			</div>
		</div>

		<div class="input-container">
			<div class="input-title">Row Output Template</div>
			<div class="input-box">
				<input type="text" v-model="value.config.row_output_template" :placeholder="`e.g. {{ parent.title }} {{ thisModuleFieldSlug }}`">
			</div>
		</div>

		<validation v-model="field"></validation>

		<input-tooltip>
			<span slot="title">Singular Table Name</span>
			<div slot="field">
				<input type="text" v-model="value.config.singular_name">
			</div>
			<div slot="tooltip">
				The singular table name determines the prefix of the foreign id database column (e.g. <i>singular_table_name</i>_id).
			</div>
		</input-tooltip>

		<input-tooltip>
			<span slot="title">Inverted Relation Name</span>
			<div slot="field">
				<input type="text" v-model="value.config.inverted_relation_name">
			</div>
			<div slot="tooltip">
				This will be the name of the function for this relation within the Model for {{ field.specific_data }}.
			</div>
		</input-tooltip>

		<show-in-list v-model="field"></show-in-list>
	</div>
</template>

<script>

import _ from 'underscore';
import FieldNameSlug from './reusables/FieldNameSlug';
import Validation from './reusables/Validation';
import FieldPlaceholder from './reusables/FieldPlaceholder';
import ShowInList from './reusables/ShowInList';

import FieldMixin from './mixins/FieldMixin';
import FieldDisplayLogic from './reusables/FieldDisplayLogic';

export default {

	name: 'AssociatedModule',

	mixins: [FieldMixin],

	props: {
		parentModules: {
			type: Array,
			default: () => ([]),
		},
		module: {
			type: Object,
			default: () => ({}),
		},
	},

	created() {
		if (!this.value.config.inverted_relation_name && this.module.singular_table_name) {
			this.value.config.inverted_relation_name = this.module.singular_table_name;
		}
	},

	computed: {

		selectedModule() {
			return _.findWhere(this.parentModules, { plural_table_name: this.field.specific_data }) || {};
		},

		selectedModuleFields() {
			if (!this.selectedModule) return [];

			return this.selectedModule.fields;
		},

	},

	components: {
		FieldDisplayLogic,
		FieldNameSlug,
		Validation,
		FieldPlaceholder,
		ShowInList,
	},

};

</script>
